/**
 * Best Sellers section — Add to Cart handler
 *
 * Adds the clicked product's variant via the Cart AJAX API (cart/add.js),
 * refreshes the Impact theme cart drawer section markup, then opens it.
 *
 * IMPORTANT: The drawer refresh/open logic assumes Impact's cart drawer is
 * rendered as a <cart-drawer> custom element from a section literally named
 * "cart-drawer" (sections/cart-drawer.liquid), which is the standard
 * Maestrooo/Impact pattern. If your theme build renamed the section or
 * exposes a different open method/event, update refreshCartDrawer() and
 * openCartDrawer() below to match — check assets/cart-drawer.js (or similar)
 * in your theme for the exact element name and public API.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-add-to-cart]');
    if (!button) return;

    event.preventDefault();
    addToCart(button);
  });

  async function addToCart(button) {
    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    const textEl = button.querySelector('[data-add-to-cart-text]');
    const originalText = textEl ? textEl.textContent : '';
    const addingLabel = button.getAttribute('data-adding-label') || 'Adding...';

    button.disabled = true;
    button.classList.add('is-loading');
    if (textEl) textEl.textContent = addingLabel;

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || 'Could not add product to cart');
      }

      await refreshCartDrawer();
      openCartDrawer();
    } catch (error) {
      console.error('[Best Sellers] Add to cart failed:', error);
      // if (textEl) textEl.textContent = 'Error';
      // setTimeout(() => {
      //   if (textEl) textEl.textContent = originalText;
      // }, 1500);
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
      if (textEl && textEl.textContent === addingLabel) {
        textEl.textContent = originalText;
      }
    }
  }

  /**
   * Re-renders the cart-drawer section via the Section Rendering API so the
   * newly added line item shows up before the drawer opens.
   */
  async function refreshCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const sectionId = cartDrawer.dataset.sectionId || 'cart-drawer';

      const response = await fetch(`${root}?sections=${sectionId}`);
      const sections = await response.json();
      const html = sections[sectionId];

      if (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');
        if (newDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
        }
      }
    } catch (error) {
      console.error('[Best Sellers] Could not refresh cart drawer markup:', error);
    }

    // Let the rest of the theme (header cart bubble/count, etc.) react too.
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  /**
   * Opens Impact's cart drawer. Tries the custom element's public open()
   * method first, then falls back to attribute/class toggling used by
   * older Impact builds, and finally fires a cart-drawer:open event that
   * the theme's own drawer script can listen for.
   */
  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    if ('open' in cartDrawer) {
      cartDrawer.setAttribute('open', '');
    }

    cartDrawer.classList.add('active', 'is-open');
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
  }
})();
